import React, { useState, useEffect, useRef } from 'react';

import "./RaceCard.css"

import EventBus from "../../common/EventBus";
import GradientGauge from '../../common/GradientGauge';
import Speedometer from '../../common/Speedometer';


function formatLapTime(milliseconds) {
  let minutes = Math.floor(milliseconds / 60000);
  let seconds = ((milliseconds % 60000) / 1000).toFixed(3); // Includes milliseconds in the seconds portion
  return minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(6, '0');
}


function convertDateToString(dateEpoch, withSeconds, withMilleconds) {


  if (dateEpoch === undefined || dateEpoch === 0 || isNaN(dateEpoch))
    return "invalid value"

  let formattedDate = "";
  const date = new Date(dateEpoch);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);
  if (withSeconds)
    formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  else
    formattedDate = `${year}/${month}/${day} ${hours}:${minutes}`;

  return formattedDate;
}

const DataRowTitle = React.memo(({ title, unit }) => {
  return (
    <div className="row">
      <div className="cardCell">
        <p className="cardTextContainer">
          {title}
        </p>
      </div>
    </div>
  );
})

const DataRowTitleColumns = () => {
  return (
    <div className="row">
      <div className="cardCell cardCellNarrow"></div>
      <div className="cardCell cardCellWide" >
        <p className="cardTextColumnHeaderContainer">min</p>
      </div>
      <div className="cardCell cardCellWide" >
        <p className="cardTextColumnHeaderContainer">max</p>
      </div>
      <div className="cardCell cardCellWide">
        <p className="cardTextColumnHeaderContainer">cur</p>
      </div>
    </div>
  )
}

const DataRowMinMax = React.memo(({ value, min, max, orientationIndicator, unit }) => {
  return (
    <div className="row">
      <div className="cardCell cardCellNarrow" >
        <p className={`cardTextContainer ${orientationIndicator === 1 ? 'orientationIndicatorRed' : orientationIndicator === -1 ? 'orientationIndicatorGreen' : ''}`}>
          {orientationIndicator}
        </p>
      </div>
      <div className="cardCell cardCellWide">
        <p className="cardTextContainer">{min}</p>
      </div>
      <div className="cardCell cardCellWide">
        <p className="cardTextContainer">{max}</p>
      </div>
      <div className="cardCell cardCellWide">
        <p className="cardTextContainer">{value}</p>
      </div>
      <div className="cardCell cardCellUnit">
        <p className="cardTextUnitContainer">{unit}</p>
      </div>
    </div>
  );
})

const DataRowMinMaxErrorDiff0 = React.memo(({ value, min, max, orientationIndicator, unit }) => {
  return (
    <div className="row">
      <div className="cardCell cardCellNarrow" >
        <p className={`cardTextContainer ${orientationIndicator === 1 ? 'orientationIndicatorRed' : orientationIndicator === -1 ? 'orientationIndicatorGreen' : ''}`}>
          {orientationIndicator}
        </p>
      </div>
      <div className="cardCell cardCellWide">
        <p className="cardTextContainer" style={{ color: min > 0 ? 'red' : 'inherit' }}>{min}</p>
      </div>
      <div className="cardCell cardCellWide">
        <p className="cardTextContainer" style={{ color: max > 0 ? 'red' : 'inherit' }}>{max}</p>
      </div>
      <div className="cardCell cardCellWide">
        <p className="cardTextContainer" style={{ color: value > 0 ? 'red' : 'inherit' }}>{value}</p>
      </div>
    </div>
  );
})

const DataRow = React.memo(({ value }) => {
  return (
    <div className="row">
      <div className="cardCell cardCellFull">
        <p className="cardTextContainer">{value}</p>
      </div>
    </div>
  );
})
const DataRowStyled = React.memo(({ value, style }) => {
  return (
    <div className="row">
      <div className="cardCell cardCellFull">
        <p className="cardTextContainer" style={style} >{value}</p>
      </div>
    </div>
  );
})

const RaceCardGlow = ({ timestamp, markerColor, mac_custom }) => {

  const [glow, setGlow] = useState(false);
  const lastTimeStampRef = useRef({});
  const lastMacCustomRef = useRef({});

  useEffect(() => {
    const deviceTimestampLast = lastTimeStampRef.current[mac_custom];
    const deviceTimestampCurrent = timestamp

    if (lastMacCustomRef.current !== mac_custom) {
      lastMacCustomRef.current = mac_custom;
      setGlow(false);
    }

    lastTimeStampRef.current[mac_custom] = deviceTimestampCurrent;

    // console.log("mac_custom", mac_custom, "deviceTimestampLast", deviceTimestampLast, "deviceTimestampCurrent", deviceTimestampCurrent);
    if (deviceTimestampLast !== undefined && (deviceTimestampLast !== deviceTimestampCurrent)) {
      // console.log("mac_custom", mac_custom, " => glow ON");
      setGlow(true);
      const timer = setTimeout(() => {
        setGlow(false)
        // console.log("mac_custom", mac_custom, " => glow OFF");
      }, 500); // 0.5-second glow duration
      return () => clearTimeout(timer);
    }
  }, [timestamp]);

  return (
    <span
      style={{
        display: 'inline-block',
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        backgroundColor: markerColor,
        boxShadow: glow ? `0 0 10px ${markerColor}, 0 0 20px ${markerColor}` : 'none', // Glowing effect
        paddingTop: '5px',
        marginRight: '15px',
      }} />
  )
}

const RaceCard = React.memo(({ index, deviceData, deviceDetails, markerColor, deviceMinMax, toast }) => {

  // console.log("RaceCard / deviceData", index, deviceData);

  /*
  function useRenderCount() {
    const renderCountRef = useRef(1);
    useEffect(() => {
      renderCountRef.current++;
    });
    return renderCountRef.current;
  }
    
  const renderCount = useRenderCount();
  console.log(`RaceCard / Render count: ${renderCount} / Date = ${Date.now()} / deviceDetails = ${deviceDetails ? deviceDetails.mac_custom : 'N/A'}`);
*/

  const getOrientationIndicator = (val) => {

    if (val == 1) {
      return <span style={{ color: 'red' }}>▲</span>;
    } else if (val == -1) {
      return <span style={{ color: 'green' }}>▼</span>;
    }

    return '';
  };

  const handleResetDeviceStorage = (deviceKey) => {
    console.log("RaceCard / handleResetDeviceStorage", deviceKey);
    EventBus.dispatch('handleResetDeviceStorage', deviceKey);

    toast.success("Information reseted", {
      position: "bottom-right",
      autoClose: 2000
    });
  };

  // if (index == 0)
  //  console.log("RaceCard / deviceData.speed", deviceData ? deviceData.speed : 'N/A');


  if (index == -1) {
    return (
      <div style={{ paddingLeft: '10px', alignSelf: 'baseline' }}>
        <div className="flex-wrap">

          <div className='row'>
            <h5 className="card-title" style={{ paddingLeft: '0px', paddingBottom: '2px' }}>Datas</h5>
          </div>

          <div style={{ height: '118px' }} />

          <DataRowTitle
            title="Speed"
          />
          <div style={{ height: '35px' }} />
          <DataRowTitle
            index={index}
            title="Throttle"
          />
          <div style={{ height: '26px' }} />
          <DataRowTitle
            index={index}
            title="Power"
          />
          <div style={{ height: '55px' }} />
          <DataRowTitle
            title="Voltage"
          />
          <DataRowTitle
            index={index}
            title="Current bat"
          />
          <DataRowTitle
            index={index}
            title="Current motor master"
          />
          <DataRowTitle
            index={index}
            title="Current motor slave"
          />
          <DataRowTitle
            index={index}
            title="Controller temp"
          />
          <DataRowTitle
            index={index}
            title="Motor temp"
          />
          <DataRowTitle
            index={index}
            title="Duty master"
          />
          <DataRowTitle
            index={index}
            title="Duty slave"
          />
          <DataRowTitle
            index={index}
            title="Acceleration"
          />
          <DataRowTitle
            index={index}
            title="BMS int. temp 1"
          />
          <DataRowTitle
            index={index}
            title="BMS int. temp 2"
          />
          <DataRowTitle
            index={index}
            title="BMS bat. temp 1"
          />
          <DataRowTitle
            index={index}
            title="BMS bat. temp 2"
          />
          <DataRowTitle
            index={index}
            title="TPMS temp 1"
          />
          <DataRowTitle
            index={index}
            title="TPMS temp 2"
          />
          <DataRowTitle
            index={index}
            title="TPMS pres 1"
          />
          <DataRowTitle
            index={index}
            title="TPMS pres 2"
          />
          <DataRowTitle
            index={index}
            title="Brake"
          />
          <DataRowTitle
            title="Autonomy left"
          />
          <DataRowTitle
            title="Battery lvl"
          />
          <DataRowTitle
            title="Smartphone bat. lvl"
          />
          <DataRowTitle
            title="Errors"
            unit=""
          />
          <DataRowTitle
            title="Last errors"
            unit=""
          />
          <DataRowTitle
            title="Updated"
            unit=""
          />
          <DataRowTitle
            title="Race started at"
            unit=""
          />
          <DataRowTitle
            title="Laps"
            unit=""
          />
        </div>
      </div>
    )
  }
  else {

    // console.log("RaceCard / deviceData", deviceData, "deviceMinMax", deviceMinMax, "deviceData?.speed", deviceData?.speed);
    // console.log("RaceCard / deviceData", deviceData.mac_custom)

    if (deviceMinMax === undefined)
      return null;
    if (deviceData === undefined)
      return null;
    if (deviceData?.speed === null)
      return null;


    // Find the best (shortest) lap time first
    let bestLapTime = 0;
    if (deviceData?.laps?.lapTimes)
      bestLapTime = Math.min(...deviceData?.laps?.lapTimes)

    let raceStartTimestamp = 0;
    if (deviceData?.laps && deviceData?.laps.hasOwnProperty('raceStartTimestamp'))
      raceStartTimestamp = deviceData.laps.raceStartTimestamp

    return (
      <div style={{ paddingLeft: '20px', borderLeft: '2px solid var(--color-middle-grey)' }}>
        <div className="flex-wrap">
          <h6 className="card-title" style={{ textAlign: 'center', marginBottom: 0 }}>


            <RaceCardGlow timestamp={(deviceData.timestamp / 2000).toFixed(0)} markerColor={markerColor} mac_custom={deviceData.mac_custom} />

            {deviceDetails ? deviceDetails.race_username : ""}{deviceDetails ? " - " + deviceDetails.ble_name : 'Unknown'}

            <button onClick={() => handleResetDeviceStorage(deviceData.mac_custom.toLowerCase())} style={{ marginLeft: '10px', border: 'none', backgroundColor: 'transparent' }}>
              <i className="fas fa-sync-alt" style={{ color: '#aaa', fontSize: '14px', position: 'relative', top: '-0px' }}></i>
            </button>
          </h6>

          <h6 className="card-title" style={{ textAlign: 'center', marginBottom: 0 }}>
            <span style={{ fontSize: '20px', marginLeft: '10px' }}>{deviceData.laps?.lapCurrent ? deviceData.laps.lapCurrent : 0}/{deviceData.laps?.nbLapsOfRace ? deviceData.laps.nbLapsOfRace : 0}</span>
          </h6>

          <Speedometer
            // key={deviceMinMax.speed.max.toFixed(0)}
            maxValue={deviceMinMax.speed.max.toFixed(0) > 10 ? deviceMinMax.speed.max.toFixed(0) : 10}
            value={deviceData['speed'].toFixed(0)}
            needleColor='var(--color-foreground)'
            startColor="#00ff00"
            endColor="#ff0000"
            segments={10}
            textColor='var(--color-foreground)'
            width={268}
            height={170}
            forceRender={true}
            needleTransitionDuration={0}
            currentValueText={deviceData['speed'].toFixed(0) + " Km/h"}
          />

          <div style={{ width: '270px', height: '55px', padding: '15px' }}>
            <GradientGauge
              min={0}
              max={100}
              current={deviceData['throttle_percent'].toFixed(0)}
              backgroundColor='var(--color-middle-grey)'
              barColorGradientStart="green"
              barColorGradientEnd="red"
              height="40px"
              borderRadius="2px"
              unit="%"
              textColor='var(--color-foreground)'
            />
          </div>

          <div style={{ width: '270px', height: '55px', padding: '15px' }}>
            <GradientGauge
              min={0}
              max={deviceMinMax.power?.max.toFixed(0)}
              current={deviceData['power'].toFixed(0)}
              backgroundColor='var(--color-middle-grey)'
              barColorGradientStart="green"
              barColorGradientEnd="red"
              height="40px"
              borderRadius="2px"
              unit="W"
              textColor='var(--color-foreground)'
            />
          </div>

          <div style={{ height: '10px' }}></div>

          <DataRowTitleColumns
            index={index}
          />

          {/*
          <DataRowMinMax
            index={index}
            unit="Km/h"
            value={deviceData['speed'].toFixed(0)}
            min={deviceMinMax.speed.min.toFixed(0) || '-'}
            max={deviceMinMax.speed.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.speed.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="%"
            value={deviceData['throttle_percent'].toFixed(0)}
            min={deviceMinMax.throttle_percent?.min.toFixed(0) || '-'}
            max={deviceMinMax.throttle_percent?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.throttle_percent.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="W"
            value={deviceData['power']}
            min={deviceMinMax.power?.min.toFixed(0) || '-'}
            max={deviceMinMax.power?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.power.dir)}
          />
    */}
          <DataRowMinMax
            index={index}
            unit="V"
            value={deviceData['voltage'].toFixed(1)}
            min={deviceMinMax.voltage?.min.toFixed(1) || '-'}
            max={deviceMinMax.voltage?.max.toFixed(1) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.voltage.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="A"
            value={deviceData['current'].toFixed(0)}
            min={deviceMinMax.current?.min.toFixed(0) || '-'}
            max={deviceMinMax.current?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.current.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="A"
            value={deviceData['current_phase1'].toFixed(0)}
            min={deviceMinMax.current_phase1?.min.toFixed(0) || '-'}
            max={deviceMinMax.current_phase1?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.current_phase1.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="A"
            value={deviceData['current_phase2'].toFixed(0)}
            min={deviceMinMax.current_phase2?.min.toFixed(0) || '-'}
            max={deviceMinMax.current_phase2?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.current_phase2.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['controller_temp'].toFixed(0)}
            min={deviceMinMax.controller_temp?.min.toFixed(0) || '-'}
            max={deviceMinMax.controller_temp?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.controller_temp.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['motor_temp'].toFixed(0)}
            min={deviceMinMax.motor_temp?.min.toFixed(0) || '-'}
            max={deviceMinMax.motor_temp?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.motor_temp.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="%"
            value={deviceData['duty_master'].toFixed(0)}
            min={deviceMinMax.duty_master?.min.toFixed(0) || '-'}
            max={deviceMinMax.duty_master?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.duty_master.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="%"
            value={deviceData['duty_slave'].toFixed(0)}
            min={deviceMinMax.duty_slave?.min.toFixed(0) || '-'}
            max={deviceMinMax.duty_slave?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.duty_slave.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="m/s²"
            value={parseFloat(deviceData['acceleration'])?.toFixed(2)}
            min={deviceMinMax.acceleration?.min.toFixed(2) || '-'}
            max={deviceMinMax.acceleration?.max.toFixed(2) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.acceleration?.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['bms_int_temp1']?.toFixed(0) || '-'}
            min={deviceMinMax?.bms_int_temp1?.min.toFixed(0) || '-'}
            max={deviceMinMax?.bms_int_temp1?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax?.bms_int_temp1?.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['bms_int_temp2']?.toFixed(0) || '-'}
            min={deviceMinMax?.bms_int_temp2?.min.toFixed(0) || '-'}
            max={deviceMinMax?.bms_int_temp2?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax?.bms_int_temp2?.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['bms_bat_temp1']?.toFixed(0) || '-'}
            min={deviceMinMax?.bms_bat_temp1?.min.toFixed(0) || '-'}
            max={deviceMinMax?.bms_bat_temp1?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax?.bms_bat_temp1?.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['bms_bat_temp2']?.toFixed(0) || '-'}
            min={deviceMinMax?.bms_bat_temp2?.min.toFixed(0) || '-'}
            max={deviceMinMax?.bms_bat_temp2?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax?.bms_bat_temp2?.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['tpms_temperature1']?.toFixed(0)}
            min={deviceMinMax?.tpms_temperature1?.min.toFixed(0) || '-'}
            max={deviceMinMax?.tpms_temperature1?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax?.tpms_temperature1?.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="°C"
            value={deviceData['tpms_temperature2']?.toFixed(0)}
            min={deviceMinMax?.tpms_temperature2?.min.toFixed(0) || '-'}
            max={deviceMinMax?.tpms_temperature2?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax?.tpms_temperature2.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="bars"
            value={deviceData['tpms_pressure1'].toFixed(1)}
            min={deviceMinMax.tpms_pressure1?.min.toFixed(1) || '-'}
            max={deviceMinMax.tpms_pressure1?.max.toFixed(1) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.tpms_pressure1.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="bars"
            value={deviceData['tpms_pressure2'].toFixed(1)}
            min={deviceMinMax.tpms_pressure2?.min.toFixed(1) || '-'}
            max={deviceMinMax.tpms_pressure2?.max.toFixed(1) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.tpms_pressure2.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="%"
            value={deviceData['brake_percent'].toFixed(0)}
            min={deviceMinMax.brake_percent?.min.toFixed(0) || '-'}
            max={deviceMinMax.brake_percent?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.brake_percent.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="km"
            value={deviceData['autonomy_left'].toFixed(0)}
            min={deviceMinMax.autonomy_left?.min.toFixed(0) || '-'}
            max={deviceMinMax.autonomy_left?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.autonomy_left.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="%"
            value={deviceData['battery_level'].toFixed(0)}
            min={deviceMinMax.battery_level?.min.toFixed(0) || '-'}
            max={deviceMinMax.battery_level?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax.battery_level.dir)}
          />
          <DataRowMinMax
            index={index}
            unit="%"
            value={deviceData['smartphone_battery_level']?.toFixed(0)}
            min={deviceMinMax?.smartphone_battery_level?.min.toFixed(0) || '-'}
            max={deviceMinMax?.smartphone_battery_level?.max.toFixed(0) || '-'}
            orientationIndicator={getOrientationIndicator(deviceMinMax?.smartphone_battery_level?.dir)}
          />
          <DataRowMinMaxErrorDiff0
            index={index}
            value={deviceData['errors'].toFixed(0)}
            min={deviceMinMax.errors?.min.toFixed(0) || '-'}
            max={deviceMinMax.errors?.max.toFixed(0) || '-'}
          />
          <DataRow
            index={index}
            value={deviceData.had_errors ? convertDateToString(deviceData.last_error_date, true) : "no error"}
          />
          <DataRow
            index={index}
            value={convertDateToString(deviceData.timestamp, true, true)}
          />

          <DataRow
            index={index}
            value={(raceStartTimestamp > 0) ? convertDateToString(raceStartTimestamp, true, false) : "N/A"}
          />


          {deviceData.laps?.lapTimes?.map((lap, index) => {

            const lapStyle = lap === bestLapTime ? { fontWeight: 'bold' } : {};
            return (
              <DataRowStyled
                key={index}
                index={index}
                value={formatLapTime(lap)}
                style={lapStyle}
              />
            )
          })}

        </div>
      </div>

    );
  }
})


export default RaceCard;
